const validator = {
  validate(value) {
    if (value.size > 10097152) return false;
    else return true;
  }
};
export default validator;
